import React, {useState} from "react";
import strapi from "/scripts/apis/strapi/index.js";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import Button from "@/components/button";
import ImageCard from "@/components/imageCard";
import { StrapiPicture } from "@/components/picture";
import Link from "next/link";

export default function Articles({articles}) {
  return <DefaultLayout
    title="Articles | Lazy Prompts"
    description="We don't just sell AI prompts. Here you can stay up-to-date on the latest AI news, enterprise use cases, and prompting techniques."
    mainClassName={css.main}
    light
  >
    <section className={css.fold}>
      <div className="sectionInner">
        <h1>
          <div>AI news, insights,</div>
          <div>ideas. Read it all.</div>
        </h1>
        <div className={css.subheadline}><b>We don&apos;t just sell AI prompts.</b> Here you can stay up-to-date on the latest AI news, enterprise use cases, and prompting techniques.</div>
      </div>
    </section>

    <section className={`light ${css.articles}`}>
      <div className="sectionInner">
        <div className={css.cards}>
          {articles
            .sort((a, b) => (new Date(b.attributes.publishedAt)).getTime() - (new Date(a.attributes.publishedAt)).getTime())
            .map((article, idx) => {
              if (idx === 0){
                return <Link href={`/articles/${article?.attributes?.slug}`} key={article.id}>
                  <a className={`dark ${css.featuredArticle}`}>
                    <div className={css.image}>
                      <StrapiPicture
                        picture={article?.attributes?.coverArt?.data?.attributes}
                        sizes={"max-width(720px) 100vw, 720px"}
                        loading="eager"
                      />
                    </div>
                    <div className={css.info}>
                      <div className={css.attribution}>By {article?.attributes?.author?.data?.attributes?.name}</div>
                      <div className={css.headline}>{article.attributes.headline}</div>
                      <div className={css.subheadline}>{article.attributes.subheadline}</div>
                      <Button label="Read it now"/>
                    </div>

                  </a>
                </Link>;
              }
              return <ImageCard
                key={article.id}
                strapiPicture={article?.attributes?.coverArt?.data?.attributes}
                sizes="(max-width: 1300px) 50vw, (max-width: 650px) 100vw, 33vw"
                light
                href={`/articles/${article?.attributes?.slug}`}
                label={article?.attributes?.headline}
              >{article?.attributes?.subheadline}.</ImageCard>;
            })}
        </div>
      </div>
    </section>

  </DefaultLayout>;
}

/*

          */

export async function getStaticProps() {
  let page = 0;
  let articles = [];
  let articlesRaw = [];
  do {
    articlesRaw = await strapi.query(strapi.endpoints.ARTICLES_FIND, {
      pagination: {
        page,
        pageSize: 100,
      },
      fields: ["id", "headline", "slug", "subheadline", "publishedAt"],
      populate: "*",
    });
    page ++;

    for (let article of articlesRaw){
      articles.push(article);
    }
  } while (articlesRaw?.data?.length > 0);

  return {
    props: {
      articles,
    },
    revalidate: 60 * 5, //once a minute
  };
}
